import { ContentParent } from "components/modules/Content/ContentParent";
import { ContentItem } from "components/modules/Content/ContentItem/ContentItem";
import React from "react";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";
import { Translate } from "components/common/Translate/Translate";
import LucideIconDynamic from "components/common/Icons/LucideIconDynamic";



export interface ImageConverterSection3ContentProps {
    template: ImageConverterPageTemplateInterface;
    variables?: Record<any, any>;
}

export const ImageConverterSection3Content = (props: ImageConverterSection3ContentProps) => {
    const item = props.template["section3"].items;

    return (
        <ContentParent>
            {item.map((content, index) => {
                return (
                    <ContentItem
                        key={index}
                        title={<Translate keyName={content.title} variables={props.variables} />}
                        description={<Translate keyName={content["subTitle"]} variables={props.variables}/>}
                        icon={<LucideIconDynamic name={content.icon} strokeWidth={1.5} width={36} height={36} />}
                    />
                );
            })}
        </ContentParent>
    );
};
